var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6143 17.8743L22.6192 17.8716H22.6096L16.9645 14.8128L11.3101 11.7485L5.65541 14.8128L0.0103386 17.8716H0.000732422L0.0056472 17.8743L0.000732422 17.877H0.0103386L5.65541 20.9359L11.3101 24.0001L16.9645 20.9359L22.6096 17.877H22.6192L22.6143 17.8743Z",
    fill: "#FF9F68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.614 6.12578L22.619 6.12332H22.6094L16.9643 3.06423L11.3098 0L5.65516 3.06423L0.0100944 6.12332H0.000488281L0.00540306 6.12578L0.000488281 6.12847H0.0100944L5.65516 9.18755L11.3098 12.2518L16.9643 9.18755L22.6094 6.12847H22.619L22.614 6.12578Z",
    fill: "#F36D24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.614 6.12578L22.619 6.12332H22.6094L16.9643 3.06423L11.3098 0L5.65516 3.06423L0.0100944 6.12332H0.000488281L0.00540306 6.12578L0.000488281 6.12847H0.0100944L5.65516 9.18755L11.3098 12.2518L16.9643 9.18755L22.6094 6.12847H22.619L22.614 6.12578Z",
    fill: "#FF9F68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0100098 5.87695V18.1234L11.3098 12.0003L0.0100098 5.87695Z",
    fill: "#FF7E34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6098 5.87695V18.1234L11.3103 12.0003L22.6098 5.87695Z",
    fill: "#FF7E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.0ef68d4a8c9c91837f69e62fc919da5c.svg";
export { ForwardRef as ReactComponent };